/* 
  When the app detect its running inside an iframe, it will render this component and inform the user.
*/

const PreventIframe = () => {
  const siteURL = window.self.location.origin; // Dynamically get the current site URL

  return (
    <div className="iframePreventer">
      <p>
        This site cannot be viewed inside an embedded frame for security
        reasons.
      </p>
      <p>
        Please open it directly:{' '}
        <a href={siteURL} target="_blank" rel="noopener noreferrer">
          {siteURL}
        </a>
      </p>
      <button onClick={() => window.open(siteURL, '_blank')} type="button">
        Open Site
      </button>
    </div>
  );
};

export default PreventIframe;
